<template>
    <NuxtLoadingIndicator color="var(--progress-gradient)" error-color="var(--button-danger-surface)" :height="2" />

    <Teleport to="body">
        <Motion
            v-if="isSpinnerVisible"
            :animate="AppLoadingIndicatorMotion.Enter"
            :initial="AppLoadingIndicatorMotion.Initial"
            :transition="AppLoadingIndicatorMotion.Transition"
            :class="ui.root()"
            role="status"
            aria-live="polite"
            aria-label="Loading">
            <div :class="ui.indicator()">
                <span :class="ui.spinner()" />
            </div>
        </Motion>
    </Teleport>
</template>

<script lang="ts" setup>
    import { MotionEase, MotionType, Opacity, PointerEvents } from '@constants/motion/defaults';

    const AppLoadingIndicatorMotion = Object.freeze({
        Initial: {
            opacity: Opacity.Hidden,
            pointerEvents: PointerEvents.None
        },
        Enter: {
            opacity: Opacity.Visible,
            pointerEvents: PointerEvents.Auto
        },
        Transition: {
            opacity: {
                type: MotionType.Tween,
                duration: 0.14,
                delay: 0.2,
                ease: MotionEase.Out
            },
            pointerEvents: {
                type: MotionType.Tween,
                duration: 0,
                delay: 0.2
            }
        }
    });

    const { isSpinnerVisible } = useAppLoadingIndicator();
    const ui = useComponentUi('appLoadingIndicator');
</script>
